import { Reveal } from "../Reveal";
import { FAQS } from "../../lib/data";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../ui/accordion";

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="relative bg-ink py-24 md:py-32">
      <div className="mx-auto max-w-4xl px-6 md:px-10">
        <div className="text-center">
          <Reveal><span className="text-xs font-bold uppercase tracking-[0.3em] text-gold">Questions</span></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-4xl font-medium leading-tight tracking-tight sm:text-5xl lg:text-6xl">
              Everything you need to know.
            </h2>
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <Accordion type="single" collapsible className="mt-14 w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-b border-white/10">
                <AccordionTrigger className="py-6 text-left font-display text-lg font-medium text-white hover:text-gold hover:no-underline md:text-xl">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base leading-relaxed text-white/55">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
